import {InputBase} from "@mui/material"
import {styled} from "@mui/material/styles"

export const Container = styled("div")`
    display: flex;
    flex-shrink: 0;
    padding: 0.75rem 1rem;
`

export const SearchBar = styled("div")`
    border: ${({theme}) => theme.colours.form.default.border};
    display: flex;
    height: 2.75rem;
    width: 100%;
    margin: 0;
    align-items: center;
    border-radius: ${({theme}) => `${theme.colours.form.input.borderRadius}`};

    &:focus-within {
        outline: ${({theme}) => `0.0625rem solid ${theme.colours.action.focused.border}`};
    }
    // Fix for IOS devices
    @supports (-webkit-touch-callout: none) {
        &:focus-within {
            border: ${({theme}) => `0.0625rem solid ${theme.colours.action.focused.border}`};
            outline: none;
        }
    }
`
interface InputProps {
    isSmallScreen: boolean
}
export const Input = styled(InputBase)<InputProps>`
    color: ${({theme}) => theme.colours.light.text.secondary};
    font-size: ${({theme}) => theme.colours.typography.body1.fontSize};
    width: 100%;

    .MuiInputBase-inputMultiline {
        margin: 0 1rem;
        padding: 0.3rem 0;
        :focus {
            outline: none;
        }
    }

    input {
        height: 2.75rem;
        margin: 0.3rem 1rem;
        display: flex;
        align-self: flex-start;
        font-family: ${({theme}) => theme.colours.components.inputText.fontFamily};
        font-weight: ${({theme}) => theme.colours.components.inputText.fontWeight};

        // This needs to remain to prevent IOS autozoom when an input box has a font size lower than 16px / 1rem
        font-size: ${({theme}) => theme.colours.components.inputText.fontSize};

        &::-ms-clear {
            display: none;
        }
        :focus {
            outline: none;
        }
        ::placeholder {
            white-space: pre-line;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            -webkit-transform: translateY(-50%);
            -ms-transform: translateY(-50%);

            // Fix for IOS devices
            @supports (-webkit-touch-callout: none) {
                font-size: ${({theme}) => theme.colours.components.inputText.fontSize};
                position: relative;
                top: 1rem;
                transform: translateY(-1rem);
                -webkit-transform: translateY(-1rem);
                -ms-transform: translateY(-1rem);
            }
        }
    }
`

export const SearchIcon = styled("div")`
    margin-right: 1rem;
    && {
        padding: 0;
        height: 1.25rem;
        width: 1.25rem;

        &:hover,
        &:active {
            border: 0;
        }

        &:focus {
            border: 0;
            border-radius: 0;
        }
    }
`
interface ClearIconProps {
    isSmallScreen: boolean
}
export const ClearIcon = styled("div")<ClearIconProps>`
    margin-right: 1rem;
    && {
        padding: 0;
        background: #ffffff;
        height: 1.25rem;
        width: 1.25rem;
        min-width: auto;

        &:hover,
        &:active {
            background: ${({theme}) => theme.colours.form.input.background};
            border: 0;
        }

        &:focus {
            border: 0;
            border-radius: 0;
        }
    }
`

export const Icon = styled("img")`
    cursor: pointer;
`
